import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { InvoiceCheckIgnoredArticlesTable } from '~/components/settings/admin/invoiceCheckIgnoredArticle/InvoiceCheckIgnoredArticlesTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/ignored-articles/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/ignored-articles',
    ...routeParams,
  }),
  component: InvoiceCheckIgnoredArticlesTable,
  validateSearch,
});

export const SETTINGS_INVOICE_CHECK_IGNORED_ARTICLES = buildRouteExport({
  Route,
  ...routeParams,
});
